import React, {useEffect} from 'react';
import { Helmet } from "react-helmet";
import config from '../../config/config';
import { useState } from 'react';

export default function ApplicationFunnel() {
  const [pathname, setPathname] = useState(window.location.pathname);
 useEffect(() => {
  const onLocationChange = () => {
    setPathname(window.location.pathname);
  };

  window.addEventListener("popstate", onLocationChange);

  const originalPushState = window.history.pushState;
  window.history.pushState = function () {
    originalPushState.apply(window.history, arguments);
    onLocationChange();
  };

  const originalReplaceState = window.history.replaceState;
  window.history.replaceState = function () {
    originalReplaceState.apply(window.history, arguments);
    onLocationChange();
  };

  return () => {
    window.removeEventListener("popstate", onLocationChange);
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
  };
}, []);

  // const isQuestionnaire = pathname.includes("/questionnaire");
  // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  // const isOldLender=pathname.includes("/lender")
  // const isOldRealtor=pathname.includes("/realtor")

    // dynamicaly adding script and link tag because of reloading issue
    useEffect(() => {
        // const delayExecution = setTimeout(() => {
          const script = document.createElement('script');
          script.src = `${config.appFunnelJsUrl}`;  
          const link = document.createElement('link');
          link.href = `${config.appFunnelCssUrl}`;
          link.rel = 'stylesheet';
    
          document.head.appendChild(script);
          document.head.appendChild(link);
        // }, 1000);
    
        // return () => clearTimeout(delayExecution);
      }, []);
  useEffect(() => {
    if (pathname.includes("/questionnaire")) {
      document.body.style.zoom = "1";
      document.documentElement.style.zoom = "1";
    }
  }, [pathname]);
  const getBasePath = () => {
    const stored = sessionStorage.getItem("APP_BASE_PATH");
    if (stored) return stored;

    const parts = window.location.pathname.split("/").filter(Boolean);
    return parts.length ? `/${parts[0]}` : "";
  };

  useEffect(() => {
    const basePath = getBasePath();
    if (basePath) {
      sessionStorage.setItem("APP_BASE_PATH", basePath);
    }

    // Repair forced root redirect
    if (window.location.pathname === "/" && basePath) {
      window.history.replaceState(null, "", basePath);
    }

    // Remove trailing slash
    if (
      window.location.pathname.endsWith("/") &&
      window.location.pathname.length > 1
    ) {
      window.history.replaceState(
        null,
        "",
        window.location.pathname.replace(/\/+$/, "")
      );
    }

    // Block native form reload
    const handleSubmit = (e) => {
      if (e.target.closest(".calque-form-widget")) {
        e.preventDefault();
        window.history.replaceState(null, "", `${basePath}/questionnaire`);
      }
    };

    document.addEventListener("submit", handleSubmit, true);

    // Neutralize injected form action="/"
    const observer = new MutationObserver(() => {
      document
        .querySelectorAll(".calque-form-widget form")
        .forEach((form) => {
          if (form.action === window.location.origin + "/") {
            form.action = "javascript:void(0)";
          }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.removeEventListener("submit", handleSubmit, true);
      observer.disconnect();
    };
  }, []);

  return (
      <div>
            <div style={{flexFlow:"unset"}}className="calque-form-widget">
            </div>
        </div>
    )
}
